import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getMonths, kFormatter } from "../../helpers";
import { Bar } from "react-chartjs-2";
import { getMonthlyTotalCallsPerService } from "../../../queries/metrics";
import useLogout from "../../common/useLogout";
import findIndex from "lodash/findIndex";
import isEmpty from "lodash/isEmpty";

const options = {
  legend: {
    position: "bottom",
  },
  tooltips: {
    mode: "index",
    intersect: false,
    xPadding: 15,
    yPadding: 15,
    callbacks: {
      title: function (t) {
        return t[0].xLabel + " - API Calls";
      },
      label: function (t, d) {
        const dstLabel = d.datasets[t.datasetIndex].label;
        const yLabel = t.yLabel;
        return " " + dstLabel + ": " + yLabel;
      },
    },
  },
  scales: {
    xAxes: [
      {
        stacked: true,
        gridLines: {
          display: false,
        },
        ticks: {
          padding: 5,
        },
      },
    ],
    yAxes: [
      {
        stacked: true,
        gridLines: {
          drawBorder: false,
          zeroLineColor: "rgba(0,0,0,.5)",
        },
        ticks: {
          beginAtZero: true,
          padding: 15,
          callback: function (val) {
            return kFormatter(val);
          },
        },
      },
    ],
  },
};

const chartDataset = JSON.stringify({
  labels: getMonths(),
  datasets: [
    {
      label: "FinstreamDS",
      data: [],
      backgroundColor: "#00cbd3",
      borderColor: "#00cbd3",
    },
    {
      label: "FinstreamVF",
      data: [],
      backgroundColor: "#00b7f3",
      borderColor: "#00b7f3",
    },
    {
      label: "FinscoreFS",
      data: [],
      backgroundColor: "#5f97f8",
      borderColor: "#5f97f8",
    },
    {
      label: "FinscoreQS",
      data: [],
      backgroundColor: "#b969ce",
      borderColor: "#b969ce",
    },
  ],
});

const TotalApiCallBarChart = ({ cableApp }) => {
  const [handleLogout] = useLogout();
  const [dataset, setDataset] = useState(JSON.parse(chartDataset));

  const createDataset = (data) => {
    const message = data["message"];
    setDataset((dataset) => {
      const newDatasets = message.map((service) => {
        const objIndex = findIndex(dataset.datasets, (dataset) => {
          return dataset.label.toLowerCase() === service.name.toLowerCase();
        });
        dataset.datasets[objIndex].data = service.datapoints;
        return dataset.datasets[objIndex];
      });
      return { ...dataset, datasets: newDatasets };
    });
  };

  const handleEmptyDataSet = () => {
    setDataset(JSON.parse(chartDataset));
  };

  useEffect(() => {
    cableApp["totalApiCalls"] = cableApp.cable.subscriptions.create(
      {
        channel: "ChartsChannel",
        chart_resource: "dashboard",
      },
      {
        connected: () => {
          getMonthlyTotalCallsPerService();
        },
        received: (data) => {
          if (!isEmpty(data.message[0])) {
            createDataset(data);
          } else {
            handleEmptyDataSet();
          }
        },
        rejected: () => {
          handleLogout();
        },
      }
    );
    return () => {
      cableApp["totalApiCalls"].unsubscribe();
    };
  }, []);

  return <Bar data={dataset} options={options} />;
};

TotalApiCallBarChart.propTypes = {
  chartValues: PropTypes.array,
  label: PropTypes.string,
};

export default TotalApiCallBarChart;
